import NginBar, { NBID, SETAG } from './components/ngin-bar'
import { SeBarBootstrapper } from './components/se-bar-bootstrapper'
import { LocationService } from './lib/location'
import request from './lib/request'
import { loadAllResources } from './lib/resource-loader'
import { beginCacheSession } from './lib/service-cache'
import { hasTouch, initializeCSSVars } from './lib/ui-helpers'
import messagesService from './services/messages'
import streamChatService from './services/stream-chat'
import { GlobalSessionEndpoint } from './session-state'

const bootstrapper = new SeBarBootstrapper(
  document,
  NginBar,
  new GlobalSessionEndpoint(new LocationService(), request),
  messagesService,
  streamChatService,
  beginCacheSession,
  loadAllResources,
  initializeCSSVars,
)

bootstrapper.run(NBID, SETAG, hasTouch).catch(err => console.log('[se-bar] error bootstrapping SE Bar', err))
